// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2YZ-Y","resendInfoText":"OnGoingPaymentBox_resendInfoText__2x73a"};